export default __webpack_public_path__ + "static/media/cumulative-quiz.19a9c202.png";